export function buildVarMap(script) {
  const varMap = {};
  const pattern = /(?:var|let|const)\s+(\w+)\s*=\s*\$\(\s*["']\[id\^=\s*['"]?([\w]+?)_*['"]?\]["']\s*\)/g;
  let match;
  while ((match = pattern.exec(script)) !== null) {
    varMap[match[1]] = `${match[2]}*`;
  }
  return varMap;
}

export function extractFieldKeyFromSelector(selector) {
  const match = selector.match(/\[id\^=\s*['"]?([\w]+?)_*['"]?\]/);
  if (match) return `${match[1]}*`;
  return null;
}

export function extractConditionBlocks(script) {
  const blocks = [];

  const ifElsePattern = /if\s*\(\s*val\s*===?\s*["'](.*?)["']\s*\)\s*\{([\s\S]*?)\}\s*(?:else\s*\{([\s\S]*?)\})?/g;
  let match;
  while ((match = ifElsePattern.exec(script)) !== null) {
    const condValue = match[1];
    const ifBody    = match[2] ?? '';
    const elseBody  = match[3] ?? '';

    blocks.push({
      condition: { field: 'self', op: 'eq', value: condValue },
      body: ifBody,
    });

    if (elseBody.trim()) {
      blocks.push({
        condition: { field: 'self', op: 'neq', value: condValue },
        body: elseBody,
      });
    }
  }

  const emptyPattern = /if\s*\(\s*val\s*===?\s*["']-1["']\s*\)\s*\{([\s\S]*?)\}\s*else\s*\{([\s\S]*?)\}/g;
  while ((match = emptyPattern.exec(script)) !== null) {
    const alreadyCaptured = blocks.some(
      b => b.condition && b.condition.value === '-1'
    );
    if (!alreadyCaptured) {
      blocks.push({
        condition: { field: 'self', op: 'eq',  value: '-1' },
        body: match[1] ?? '',
      });
      blocks.push({
        condition: { field: 'self', op: 'neq', value: '-1' },
        body: match[2] ?? '',
      });
    }
  }

  return blocks;
}

export function extractErrorMessage(script) {
  const match = script.match(/msg\s*:\s*["']([^"']+)["']/);
  return match ? match[1] : 'Validation failed.';
}
